import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAuth from '@common/lib/auth';
import qs from 'qs';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { publicRoute, protectedRoute } from './config';
const routes = publicRoute.concat(protectedRoute);

Vue.use(VueRouter);

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes,
    // set custom query resolver
    parseQuery(query) {
      return qs.parse(query);
    },
    stringifyQuery(query) {
      var result = qs.stringify(query);

      return result ? '?' + result : '';
    },
    // scrollBehavior(to, from, savedPosition) {
    //   // 페이징 처리 되어있는 부분은 예외 처리 (해당페이지에서 바로 처리) 또는 페이지로딩이 너무 긴 페이지
    //   if (
    //     to.name == 'Shop.List' ||
    //     to.name == 'Shops.search' ||
    //     to.name == 'Mobile.List' ||
    //     to.name == 'InternetCommerce.List' ||
    //     to.name == 'Mobile.View' ||
    //     to.name == 'InternetCommerce.Detail' ||
    //     to.name == 'Mobile.PromiseList' ||
    //     to.name == 'Apply.Main' ||
    //     to.name == 'Home' ||
    //     to.name == 'InternetCommerce.Main'
    //   ) {
    //     // return;
    //   }

    //   console.log('savedPositionsavedPositionsavedPosition');
    //   console.log(savedPosition);
    //   console.log(this.$refs.routerView);

    //   if (savedPosition) {
    //     return new Promise((resolve, reject) => {
    //       setTimeout(() => {
    //         resolve({ left: 0, top: 0 });
    //       }, 100);
    //     });
    //   } else {
    //     return { x: 0, y: 0 };
    //   }
    // },
  });

const router = new createRouter();

router.beforeEach(async (to, from, next) => {
  NProgress.configure({ showSpinner: false });
  NProgress.start();

  const matched = to.matched.slice().reverse();
  const requiresAuth = matched.find(
    record => record.meta.requiresAuth !== undefined,
  );
  const preventAuth = matched.find(
    record => record.meta.preventAuth !== undefined,
  );

  const isAuthenticated = await VueAuth.isAuthenticated(true);

  console.log('to.fullPath');
  console.log(to.fullPath);
  console.log(isAuthenticated);
  console.log(requiresAuth);
  // console.log(requiresAuth.meta.requiresAuth);
  // requiresAuth
  if (
    //!store.getters['auth/IS_AUTHENTICATED'] &&
    !isAuthenticated &&
    //to.matched.some(record => record.meta.requiresAuth)
    requiresAuth &&
    requiresAuth.meta.requiresAuth
  ) {
    console.log(1111111111);
    //true 면 인트로 이미 확인
    // 인트로 화면으로 이동 ( 처음 접속시 ) - 특가상품 하나페이 신청현황 바로 접속시 제외 (외부접속)
    //http://172.30.1.85:3001/Mobile/ApplyList?dl=hanapay
    //http://172.30.1.85:3001/Shops/List/3067
    if (
      to.fullPath.indexOf('/Mobile/ApplyList?dl=') == -1 &&
      to.fullPath.indexOf('/Shops/List/') == -1
    ) {
      if (!VueAuth.isIntroCheck()) {
        next(`/Intro`);
      } else {
        next(`/auth/login?isRoot=1`);
      }
    } else {
      // 특가 상품 접속시 인트로 생략
      next(`/auth/login?isRoot=1&redir=${encodeURIComponent(to.fullPath)}`);
    }
  }
  // preventAuth
  else if (
    //store.getters['auth/IS_AUTHENTICATED'] &&
    isAuthenticated &&
    //to.matched.some(record => record.meta.preventAuth)
    preventAuth &&
    preventAuth.meta.preventAuth
  ) {
    console.log(222222222);
    next('/?isRoot=2');
    NProgress.done();
  } else {
    console.log(33333333);
    // 특가 접속시 ( 특가 리스트, 상세, 스팩보기 페이지는 비로그인 상태로 접속 가능 )
    // /Mobile/DealDetail, /Mobile/DealList, /Mobile/DeviceInfo
    if (to.fullPath.indexOf('/Auth/Login?dl_id') != -1) {
      if (
        to.fullPath.indexOf('dl_id=ocb_') != -1 ||
        to.fullPath.indexOf('dl_id=hanapay_') != -1 ||
        to.fullPath.indexOf('dl_id=perce_') != -1
      ) {
        next();
      } else {
        next('/');
      }
      console.log(44444444);
    } else {
      console.log(55555555);
      next();
    }
  }
});
router.afterEach((to, from) => {
  NProgress.done();
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

// 청크파일 ( 배포파일 )이 변경되면 사용자가 사용중일때 기존 파일이 없기때문에 오류가 발생한다. 그래서 새로고침으로 처리
router.onError(error => {
  console.error(error);

  if (error.name === 'ChunkLoadError') {
    // window.location.href = nextPath || '/';
    window.location.reload();
  }
});

export default router;
